(() => {
  // app/scripts/free-shipping-bar.js
  if (!customElements.get("progress-bar-dynamic-gifting")) {
    class ProgressBar extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.discountAppliedHandler = (e) => {
          if (!e || !e.cart || e.cart.item_count == 0) return;
          const totalPrice = e.estimatedTotal || e.cart.total_price;
          const totalPriceElm = document.querySelector("cart-component .cart-total-price");
          if (totalPrice != parseInt(this.getAttribute("data-total-price"))) {
            if (parseInt(totalPriceElm.getAttribute("data-origin")) > parseInt(totalPriceElm.getAttribute("data-api-total-price"))) {
              if (e.cart.original_total_price > parseInt(totalPriceElm.getAttribute("data-api-total-price"))) {
                this.setAttribute("data-total-price", totalPrice);
                this.setProgressValueV2(totalPrice);
              }
            } else {
              this.setAttribute("data-total-price", totalPrice);
              this.setProgressValueV2(totalPrice);
            }
          }
        };
        document.body.addEventListener("docapp-discount-applied", this.discountAppliedHandler);
        this.setProgressValue();
      }
      disconnectedCallback() {
        document.body.removeEventListener("docapp-discount-applied", this.discountAppliedHandler);
      }
      getMilestonePercent(i, iconWidth, gap, containerWidth) {
        const iconCenterX = gap * (i + 1) + iconWidth * i + iconWidth / 2;
        const percent = iconCenterX / containerWidth * 100;
        return percent;
      }
      calculateCartPercent(cartValue, milestones) {
        const iconWithText = this.querySelector(".progress-bar-iwt");
        const blockItem = iconWithText.querySelector(".block-item");
        const iconWithTextStyle = window.getComputedStyle(iconWithText);
        const blockItemStyle = window.getComputedStyle(blockItem);
        const iconWidth = parseInt(blockItemStyle.width);
        const containerWidth = parseInt(iconWithTextStyle.width);
        const n = milestones.length;
        const gap = (containerWidth - n * iconWidth) / (n + 1);
        const milestonePercents = milestones.map((_, i) => this.getMilestonePercent(i, iconWidth, gap, containerWidth));
        if (cartValue <= milestones[0]) {
          const ratio = cartValue / milestones[0];
          return ratio * milestonePercents[0];
        }
        const lastIndex = milestones.length - 1;
        if (cartValue >= milestones[lastIndex]) {
          return 100;
        }
        for (let i = 1; i < milestones.length; i++) {
          if (cartValue <= milestones[i]) {
            const deltaValue = milestones[i] - milestones[i - 1];
            const deltaPercent = milestonePercents[i] - milestonePercents[i - 1];
            const ratio = (cartValue - milestones[i - 1]) / deltaValue;
            return milestonePercents[i - 1] + ratio * deltaPercent;
          }
        }
      }
      setProgressValue() {
        if (document.querySelector("cart-component").classList.contains("is-empty")) {
          return;
        }
        const progressBar = this.querySelector(".js-progress-bar");
        const cartTotalPrice = +this.getAttribute("data-total-price");
        const threshold1 = this.getAttribute("data-threshold1");
        const threshold2 = this.getAttribute("data-threshold2");
        const threshold3 = this.getAttribute("data-threshold3");
        const milestones = [+threshold1];
        if (threshold2 && threshold2 != "0") {
          milestones.push(+threshold2);
        }
        if (threshold3 && threshold3 != "0") {
          milestones.push(+threshold3);
        }
        const percent = this.calculateCartPercent(cartTotalPrice, milestones);
        progressBar.style.setProperty("--percent", Number(percent.toFixed(2)) + "%");
      }
      setProgressValueV2(totalPrice) {
        document.dispatchEvent(new CustomEvent("cart:build", { detail: { cssSelector: ".js-sb-cart-free-shipping", docappTotalPrice: totalPrice } }));
      }
    }
    customElements.define("progress-bar-dynamic-gifting", ProgressBar);
  }
})();
